<div class="tag-container" [class.withBG]="withBG" [ngClass]="color">
    <div [ngClass]="{'link': closable}">
        <span class="label">{{tagAlias || tag}}</span>
        <i class="icon-cross-circle" *ngIf="closable"></i>
    </div>
</div>
